<script setup lang="ts">
    import { useOrderStore } from "~/composables/store/order";
    const orderStore = useOrderStore();

    const { n } = useI18n();

    const r$ = orderStore.validation.r$;

    const productItems = computed(
        () =>
            orderStore.options.products
                .map((product) => {
                    const priceItem = orderStore.meta.pricelist[product.id];

                    if (!priceItem || !priceItem.active) {
                        return undefined;
                    }

                    return {
                        value: product.id,
                        title: `${product.label} - ${n(priceItem.price / 100, "currency")}`,
                    };
                })
                .filter((product) => product !== undefined) as Array<{
                value: number;
                title: string;
            }>,
    );

    const selectedProductDescription = computed(() => {
        if (selectedProductId.value === undefined) {
            return undefined;
        }

        const description = orderStore.options.products.find(
            (item) => item.id === selectedProductId.value,
        )?.description;

        if (description === undefined || description.length === 0) {
            return undefined;
        }

        return description;
    });

    const selectedProductId = computed({
        get() {
            const selectedProduct = orderStore.currentOrder.products.find(
                (product) => product.amount > 0,
            );
            return selectedProduct ? selectedProduct.id : undefined;
        },
        set(value: number) {
            orderStore.helpers.setService(value);
        },
    });

    watch(selectedProductId, () => {
        orderStore.helpers.setService(selectedProductId.value);
    });
</script>

<template>
    <shared-labeled-field
        v-slot="{ ariaLabelledby }"
        :label="$t('checkout.service.label')"
    >
        <VSelect
            v-model="selectedProductId"
            class="mb-2"
            :aria-labelledby="ariaLabelledby"
            :item-props="true"
            :items="productItems"
            hide-details="auto"
            :error-messages="r$.$errors.products.$self"
            @focusout="r$.$fields.products.$touch"
        />
    </shared-labeled-field>
    <VAlert
        v-if="selectedProductDescription !== undefined"
        class="mb-2"
        density="compact"
    >
        {{ selectedProductDescription }}
    </VAlert>
</template>
